import { reactive } from 'vue'
import {
  flareColorChoices,
  flareFOVChoices,
  flareIntensityChoices,
  flareTypeChoices,
  lensEraChoices
} from './constants'

// Module-level singleton (not per-component-instance) so the two side-by-side
// LensDetailsContent instances in the comparison view can synchronize the
// height of their "Notable Films" block, keeping the "Notes" row that
// follows aligned horizontally between them.
export const notableFilmsHeights = reactive({ left: 0, right: 0 })

export const getLensPropOptionLabel = (prop, value) => {
  switch (prop) {
    case 'flareColor':
      return getLabels(value, flareColorChoices)

    case 'flareType':
      return getLabels(value, flareTypeChoices)

    case 'lensEra':
      return getLabels(value, lensEraChoices)

    case 'flareIntensity':
      return getLabels(value, flareIntensityChoices)

    case 'FOV':
      return getLabels(value, flareFOVChoices)

    default:
      return null
  }
}

function getLabels(idsString, mapArray) {
  if (!idsString) return null
  const idToNameMap = mapArray.reduce((map, choice) => {
    map[choice.id] = choice.name
    return map
  }, {})

  return idsString
    .split(',')
    .map(id => idToNameMap[id])
    .join(', ')
}
